import React from 'react';
import { Gate, gateType } from './gate';
import { DualGate } from './dualGate';
import { MathJax } from 'better-react-mathjax';


const gates: gateType[] = [
    { id: 0, type: 0, color: 'bg-blue-900', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{H}\\)"}</MathJax></span>, name: "h" },
    { id: 1, type: 0, color: 'bg-blue-600', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{X}\\)"}</MathJax></span>, name: "x" },
    { id: 2, type: 0, color: 'bg-red-600', child: <span className='text-black  text-sm'><MathJax>{"\\(\\text{Y}\\)"}</MathJax></span>, name: "y" },
    { id: 3, type: 0, color: 'bg-gray-600', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{Z}\\)"}</MathJax></span>, name: "z" },
    { id: 4, isRotationGate: true, ratio: '0', type: 0, color: 'bg-orange-300', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{R}_x\\)"}</MathJax></span>, name: "rx" },
    { id: 5, isRotationGate: true, ratio: '0', type: 0, color: 'bg-green-300', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{R}_y\\)"}</MathJax></span>, name: "ry" },
    { id: 6, isRotationGate: true, ratio: '0', type: 0, color: 'bg-pink-300', child: <span className='text-black text-sm'><MathJax>{"\\(\\text{R}_z\\)"}</MathJax></span>, name: "rz" },
    { id: 7, type: 0, color: 'bg-pink-600', child: <span className='text-black text-sm'><MathJax>{"\\(\\sqrt{\\text{X}}\\)"}</MathJax></span>, name: "sqrtx" },
    { id: 8, type: 0, color: 'bg-pink-600', child: <span className='text-black text-sm'><MathJax>{"\\(\\sqrt{\\text{Y}}\\)"}</MathJax></span>, name: "sqrty" },
    { id: 9, type: 0, color: 'bg-pink-600', child: <span className='text-black text-sm'><MathJax>{"\\(\\sqrt{\\text{Z}}\\)"}</MathJax></span>, name: "sqrtz" },
    { id: 12, type: 4, color: "", child: <span></span>, name: "" }

];

const dualGates: gateType[] = [
    { id: 0, type: 1, color: 'bg-blue-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CX}\\)"}</MathJax></span>, name: "cx" },
    { id: 1, type: 1, color: 'bg-red-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CY}\\)"}</MathJax></span>, name: "cy" },
    { id: 2, type: 1, color: 'bg-gray-400', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CZ}\\)"}</MathJax></span>, name: "cz" },

    { id: 3, isRotationGate: true, ratio: '0', type: 1, color: 'bg-orange-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CR}_x\\)"}</MathJax></span>, name: "crx" },
    { id: 4, isRotationGate: true, ratio: '0', type: 1, color: 'bg-green-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CR}_y\\)"}</MathJax></span>, name: "cry" },
    { id: 5, isRotationGate: true, ratio: '0', type: 1, color: 'bg-pink-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CR}_z\\)"}</MathJax></span>, name: "crz" },

    { id: 8, type: 1, color: 'bg-red-400', child: <span className='text-black text-[10px]'><MathJax>{"\\(\\text{SWAP}\\)"}</MathJax></span>, name: "swap" },

    { id: 6, type: 2, color: 'bg-gray-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CCX}\\)"}</MathJax></span>, name: "ccx" },
    { id: 7, type: 2, color: 'bg-gray-300', child: <span className='text-black text-xs'><MathJax>{"\\(\\text{CCZ}\\)"}</MathJax></span>, name: "ccz" },

    { id: 4, type: 3, color: "", child: <span className='text-black text-xs'>0</span>, name: "" },
]




const Gates = () => {
    return (
        <div className='justify-between flex flex-row flex-wrap gap-2 items-center pb-1'>

            <div className='flex flex-row gap-2 items-center'>
                One-qubit Gates
                {gates.filter(g => g.type == 0).map(g => (
                    <div className='w-10'>
                        <Gate showOptions={false} key={g.id} gate={g} />
                    </div>
                ))}
            </div>
            <div className='flex flex-row gap-2 items-center'>
                Multiqubit gates
                {dualGates.filter(g => g.type == 1 || g.type == 2).map(g => (
                    <div className='w-10'>
                        <DualGate showOptions={false} key={g.id} gate={g} />
                    </div>
                ))}
            </div>
        </div>

    )
}

export default Gates